"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadUserInfo = loadUserInfo;
exports.editUserInfo = editUserInfo;
exports.editUserClient = editUserClient;
exports.deleteUserInfoGroup = deleteUserInfoGroup;
exports.deleteUserInfoClient = deleteUserInfoClient;
exports.deleteUser = deleteUser;
exports.watchLoadUserInfo = watchLoadUserInfo;
exports.watchEditUserInfo = watchEditUserInfo;
exports.watchEditUserClient = watchEditUserClient;
exports.watchDeleteUserInfoGroup = watchDeleteUserInfoGroup;
exports.watchDeleteUserInfoClient = watchDeleteUserInfoClient;
exports.watchDeleteUser = watchDeleteUser;
exports["default"] = exports.userSagas = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _actions = _interopRequireDefault(require("./actions"));

var _utils = require("../../../utils");

var _marked = _regenerator["default"].mark(loadUserInfo),
    _marked2 = _regenerator["default"].mark(editUserInfo),
    _marked3 = _regenerator["default"].mark(editUserClient),
    _marked4 = _regenerator["default"].mark(deleteUserInfoGroup),
    _marked5 = _regenerator["default"].mark(deleteUserInfoClient),
    _marked6 = _regenerator["default"].mark(deleteUser),
    _marked7 = _regenerator["default"].mark(watchLoadUserInfo),
    _marked8 = _regenerator["default"].mark(watchEditUserInfo),
    _marked9 = _regenerator["default"].mark(watchEditUserClient),
    _marked10 = _regenerator["default"].mark(watchDeleteUserInfoGroup),
    _marked11 = _regenerator["default"].mark(watchDeleteUserInfoClient),
    _marked12 = _regenerator["default"].mark(watchDeleteUser);

function loadUserInfo(api, action) {
  var _action$payload, userId, clientId, _action$payload$withG, withGroup, user;

  return _regenerator["default"].wrap(function loadUserInfo$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _action$payload = action.payload, userId = _action$payload.userId, clientId = _action$payload.clientId, _action$payload$withG = _action$payload.withGroup, withGroup = _action$payload$withG === void 0 ? false : _action$payload$withG;
          _context.prev = 1;
          _context.next = 4;
          return api.getUser({
            id: userId,
            clientId: clientId,
            withGroup: withGroup
          }).then(function (p) {
            return p.request;
          });

        case 4:
          user = _context.sent;
          _context.next = 7;
          return (0, _effects.put)(_actions["default"].loadUserInfoSuccess(user));

        case 7:
          _context.next = 13;
          break;

        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](1);
          _context.next = 13;
          return (0, _effects.put)(_actions["default"].loadUserInfoError(_context.t0));

        case 13:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[1, 9]]);
}

function editUserInfo(api, action) {
  var _action$payload2, userId, clientId, profile;

  return _regenerator["default"].wrap(function editUserInfo$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _action$payload2 = action.payload, userId = _action$payload2.userId, clientId = _action$payload2.clientId, profile = _action$payload2.profile;
          _context2.prev = 1;
          _context2.next = 4;
          return api.editUserProfile({
            id: userId,
            clientId: clientId,
            profile: profile
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _context2.next = 6;
          return (0, _effects.put)(_actions["default"].editUserInfoSuccess(userId));

        case 6:
          _context2.next = 12;
          break;

        case 8:
          _context2.prev = 8;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 12;
          return (0, _effects.put)(_actions["default"].editUserInfoError(_context2.t0));

        case 12:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 8]]);
}

function editUserClient(api, action) {
  var _action$payload3, userId, clientId, settings, metadata;

  return _regenerator["default"].wrap(function editUserClient$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _action$payload3 = action.payload, userId = _action$payload3.userId, clientId = _action$payload3.clientId, settings = _action$payload3.settings, metadata = _action$payload3.metadata;
          _context3.prev = 1;
          _context3.next = 4;
          return api.editUserClient({
            id: userId,
            clientId: clientId,
            settings: settings,
            metadata: metadata
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _context3.next = 6;
          return (0, _effects.put)(_actions["default"].editUserClientSuccess());

        case 6:
          _context3.next = 12;
          break;

        case 8:
          _context3.prev = 8;
          _context3.t0 = _context3["catch"](1);
          _context3.next = 12;
          return (0, _effects.put)(_actions["default"].editUserClientError(_context3.t0));

        case 12:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[1, 8]]);
}

function deleteUserInfoGroup(api, action) {
  var _action$payload4, userId, groupId, clientId;

  return _regenerator["default"].wrap(function deleteUserInfoGroup$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _action$payload4 = action.payload, userId = _action$payload4.userId, groupId = _action$payload4.groupId, clientId = _action$payload4.clientId;
          _context4.prev = 1;
          _context4.next = 4;
          return api.deleteUserGroup({
            userId: userId,
            groupId: groupId,
            clientId: clientId
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _context4.next = 6;
          return (0, _effects.put)(_actions["default"].deleteUserInfoGroupSuccess(groupId));

        case 6:
          _context4.next = 12;
          break;

        case 8:
          _context4.prev = 8;
          _context4.t0 = _context4["catch"](1);
          _context4.next = 12;
          return (0, _effects.put)(_actions["default"].deleteUserInfoGroupError(_context4.t0));

        case 12:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[1, 8]]);
}

function deleteUserInfoClient(api, action) {
  var _action$payload5, userId, clientId;

  return _regenerator["default"].wrap(function deleteUserInfoClient$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _action$payload5 = action.payload, userId = _action$payload5.userId, clientId = _action$payload5.clientId;
          _context5.prev = 1;
          _context5.next = 4;
          return api.deleteUserClient({
            userId: userId,
            clientId: clientId
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _context5.next = 6;
          return (0, _effects.put)(_actions["default"].deleteUserInfoClientSuccess(clientId));

        case 6:
          _context5.next = 12;
          break;

        case 8:
          _context5.prev = 8;
          _context5.t0 = _context5["catch"](1);
          _context5.next = 12;
          return (0, _effects.put)(_actions["default"].deleteUserInfoClientError(_context5.t0));

        case 12:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[1, 8]]);
}

function deleteUser(api, action) {
  var userId;
  return _regenerator["default"].wrap(function deleteUser$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          userId = action.payload.userId;
          _context6.prev = 1;
          _context6.next = 4;
          return api.deleteUser(userId).then(function (p) {
            return p.request;
          });

        case 4:
          _context6.next = 6;
          return (0, _effects.put)(_actions["default"].deleteUserSuccess(userId));

        case 6:
          _context6.next = 12;
          break;

        case 8:
          _context6.prev = 8;
          _context6.t0 = _context6["catch"](1);
          _context6.next = 12;
          return (0, _effects.put)(_actions["default"].deleteUserError(_context6.t0));

        case 12:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, null, [[1, 8]]);
}

function watchLoadUserInfo(api) {
  return _regenerator["default"].wrap(function watchLoadUserInfo$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadUserInfo), loadUserInfo, api);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}

function watchEditUserInfo(api) {
  return _regenerator["default"].wrap(function watchEditUserInfo$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].editUserInfo), editUserInfo, api);

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}

function watchEditUserClient(api) {
  return _regenerator["default"].wrap(function watchEditUserClient$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].editUserClient), editUserClient, api);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}

function watchDeleteUserInfoGroup(api) {
  return _regenerator["default"].wrap(function watchDeleteUserInfoGroup$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].deleteUserInfoGroup), deleteUserInfoGroup, api);

        case 2:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10);
}

function watchDeleteUserInfoClient(api) {
  return _regenerator["default"].wrap(function watchDeleteUserInfoClient$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].deleteUserInfoClient), deleteUserInfoClient, api);

        case 2:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked11);
}

function watchDeleteUser(api) {
  return _regenerator["default"].wrap(function watchDeleteUser$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].deleteUser), deleteUser, api);

        case 2:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked12);
}

var userSagas = function userSagas(api) {
  return [(0, _effects.fork)(watchLoadUserInfo, api), (0, _effects.fork)(watchEditUserInfo, api), (0, _effects.fork)(watchEditUserClient, api), (0, _effects.fork)(watchDeleteUserInfoGroup, api), (0, _effects.fork)(watchDeleteUserInfoClient, api), (0, _effects.fork)(watchDeleteUser, api)];
};

exports.userSagas = userSagas;
var _default = userSagas;
exports["default"] = _default;
//# sourceMappingURL=sagas.js.map